'use client'

import type { NavGroup } from '@graftcode/design-system'
import { Icon, Tooltip } from '@graftcode/design-system'

import { IS_CODE_SANDBOX_ENABLED } from '@common/components/MobileMenu/variants/AcademyMobileMenu/academy-mobile-menu.const'

import { DOCS_ROUTES } from '@/shared/docs-shared.const'
import { ACADEMY_LAYOUT_TEST_IDS } from '@/shared/docs-test-ids.const'
import {
  ACADEMY_NAV_SECTIONS,
  getAcademyBaseUrl,
  getDocsSidebarNavUrl,
  isDocsSidebarNavItemActive,
} from '@/shared/utils/docsSidebarNav'

export function buildMenuItems(pathname: string): NavGroup[] {
  const path = pathname?.split('?')[0] || ''

  if (path.startsWith(DOCS_ROUTES.quickStart)) {
    return [
      {
        items: [
          {
            label: 'Back to Home',
            url: getAcademyBaseUrl(),
            icon: Icon.ArrowLeftRegular,
            active: false,
          },
        ],
      },
    ]
  }

  return ACADEMY_NAV_SECTIONS.map((section) => ({
    label: section.label,
    items: section.items.map((item) => {
      const isCodeSandboxItem = item.id === 'codeSandbox'
      const disabled = isCodeSandboxItem ? !IS_CODE_SANDBOX_ENABLED : false

      return {
        id: item.id,
        label: item.label,
        url: getDocsSidebarNavUrl(item),
        icon: item.icon,
        active: disabled ? false : isDocsSidebarNavItemActive(item.id, path),
        disabled,
        slotRight:
          isCodeSandboxItem && !IS_CODE_SANDBOX_ENABLED ? (
            <Tooltip content="Coming soon" placement="bottom" showArrow>
              <span
                data-testid={ACADEMY_LAYOUT_TEST_IDS.codeSandboxTooltip}
                aria-hidden
                style={{
                  position: 'absolute',
                  inset: 0,
                  pointerEvents: 'auto',
                  cursor: 'help',
                }}
              />
            </Tooltip>
          ) : undefined,
      }
    }),
  }))
}
